<template>
  <!-- 账户管理---修改企业信息 -->
  <div class="page box_column">
    <Breadcrumb title="企业信息" :breadcrumb="breadcrumb" />
    <edit-Item class="content" />
  </div>
</template>

<script>
import { breadcrumb } from '@/mixins/index.js';
import { companyEdit } from '@account/static/data.js';
import editItem from '@account/components/enterprise/edit';
export default {
  mixins: [breadcrumb],
  components: {
    editItem,
  },
  data() {
    return {
      companyList: [{ title: '企业基本信息' }, { title: '营业执照' }, { title: '企业法人/经办人' }],
      companyEdit,
    };
  },
  methods: {
    // 修改提交
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      this.$refs.companyInfo.map(item => {
        console.log(item.formList);
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 100%;
}
.content {
  flex: 1;
  background: @bg-white;
}
</style>
